import { Box } from '@mui/material';
import React from 'react';
import LimitedFree from './LimitedFree.svg';

export function LimitedFreeIcon() {
  return (
    <Box
      component="img"
      src={LimitedFree.src}
      width={22}
      height={22}
      sx={{
        width: `${22}px`,
        height: `${22}px`,
      }}
    />
  );
}
